import { ResponsePostMerchflows_merchflowId_ExportsBatch } from "@CommonApi/merchflows/_merchflowId_/exports/batch";
import { sleep } from "src/utils/sleep";

type ExportBatchStatus = ResponsePostMerchflows_merchflowId_ExportsBatch["status"];
type ExportBatchType = ResponsePostMerchflows_merchflowId_ExportsBatch["type"];

interface PollExportBatchOptions {
  type: ExportBatchType;
  getBatch: () => Promise<ResponsePostMerchflows_merchflowId_ExportsBatch>;
  onBatchStatusChange?: (batch: ResponsePostMerchflows_merchflowId_ExportsBatch) => void;
  isPollingActive?: () => boolean;
  wait?: (milliseconds: number) => Promise<unknown>;
}

const EXPORT_BATCH_POLL_INTERVAL_MS = 10_000;
const NON_PDF_EXPORT_BATCH_MAX_POLL_ATTEMPTS = 50;

export const isExportBatchPendingStatus = (status: ExportBatchStatus) =>
  status === "NOT_STARTED" || status === "IN_PROGRESS";

export const pollExportBatchUntilTerminal = async ({
  type,
  getBatch,
  onBatchStatusChange,
  isPollingActive = () => true,
  wait = sleep,
}: PollExportBatchOptions) => {
  const isPdfExport = type === "pdfV2";
  let attemptsRemaining = NON_PDF_EXPORT_BATCH_MAX_POLL_ATTEMPTS;

  while (isPdfExport || attemptsRemaining-- > 0) {
    if (isPdfExport && !isPollingActive()) return null;

    await wait(EXPORT_BATCH_POLL_INTERVAL_MS);
    if (isPdfExport && !isPollingActive()) return null;

    const batch = await getBatch();
    if (isPdfExport && !isPollingActive()) return null;

    onBatchStatusChange?.(batch);
    if (!isExportBatchPendingStatus(batch.status)) return batch;
  }

  return null;
};
